<template>
  <div v-if="isAuthenticated">
    <v-subheader>Nutzer</v-subheader>
    <v-list-item v-for="(item, i) in items" :key="i" :to="item.link">
      <v-list-item-icon>
        <v-icon v-text="item.icon"></v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title v-text="item.text"></v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import { ActionEnum } from "@/store/enum/authActionEnum";
import { ResourceEnum } from "@/store/enum/authResourceEnum";
import { UserModule } from "@/store/modules/me-user.store";

@Component
export default class TheUserList extends Vue {
  ActionEnum = ActionEnum;
  ResourceEnum = ResourceEnum;

  get items() {
    return [
      {
        icon: "mdi-account-outline",
        text: "Profil",
        link: "/profile"
      }
    ];
  }

  get isAuthenticated() {
    return UserModule.isAuthenticated;
  }
}
</script>

<style scoped></style>
